import React, { useContext, useState, useRef } from "react";
import stylesArabic from "./HomeHero.module.css";
import styles from "./HomeHero_arabic.module.css";
import Hero from "./Hero.webp";
import { HomePageContext } from "../../store/HomePageContext.jsx";
import { LanguageContext } from "../../Component/LanguageContext/LanguageContext.jsx";

const HomeHero = () => {
  console.log('HomeHero Component Mounted');
  const { homeScreenDetails, loading, error } = useContext(HomePageContext);
  const { language } = useContext(LanguageContext);
  const stylesSelected = language === "ar" ? styles : stylesArabic;
  const [videoError, setVideoError] = useState(false);
  const videoRef = useRef(null);

  console.log('HomeHero State:', {
    loading,
    error,
    hasHomeScreenDetails: !!homeScreenDetails,
    language
  });

  if (loading) {
    console.log('HomeHero Loading');
    return <p>Loading...</p>;
  }
  if (error) {
    console.error('HomeHero Error:', error);
    return <p>Error loading data</p>;
  }

  const title =
    homeScreenDetails?.homeScreenDetailsSec1?.title || "Default Title";
  const description =
    homeScreenDetails?.homeScreenDetailsSec1?.description ||
    "Default description";
  const videoUrl = homeScreenDetails?.homeScreenDetailsSec1?.videoUrl || "";
  const signUpText =
    homeScreenDetails?.homeScreenDetailsSec1?.signUpText || "Sign Up";

  console.log('HomeHero Data:', {
    title,
    hasDescription: !!description,
    hasVideoUrl: !!videoUrl,
    hasSignUpText: !!signUpText
  });

  const handleVideoError = () => {
    console.log('Video Error Occurred');
    setVideoError(true);
    if (videoRef.current) {
      videoRef.current.style.display = "none";
    }
  };

  return (
    <div className={stylesSelected.herosection}>
      <div className={stylesSelected.heroContainer}>
        {videoError ? (
          <img
            src={Hero}
            alt="Hero Background"
            className={stylesSelected.backgroundImage}
          />
        ) : (
          videoUrl && (
            <video
              ref={videoRef}
              className={stylesSelected.backgroundVideo}
              src={videoUrl}
              poster={Hero}
              autoPlay
              muted
              loop
              playsInline
              onError={handleVideoError}
            />
          )
        )}
        <div className={stylesSelected.overlay}></div>
        <div className={stylesSelected.rightoverlay}> </div>
        <div className={stylesSelected.leftoverlay}></div>
        <div className={stylesSelected.bottomoverlay}></div>
        <div className={stylesSelected.content}>
          <h1 className={stylesSelected.title}>{title}</h1>
          <p className={stylesSelected.description}>{description}</p>
          {/* {signUpText && (
            <button className={styles.signUpButton}>{signUpText}</button>
          )} */}
        </div>
      </div>
    </div>
  );
};

export default HomeHero;
